export default {
  title: "Reject Corrective Work",
  content:
    "<div>Are you sure you want to <b class='text-error'>reject</b> the <b class='text-info'>Performed Corrective Work</b> for this <b class='text-info'>Issue</b>? The <b class='text-info'>Issue</b> will no longer be set as Corrected. This is also reflected in <b class='text-info'>Work Orders</b>, if applicable.<br><br>Rejection <b class='text-negative text-uppercase'>cannot</b> be undone!</div>",
  input_label: "Reasoning",
}
